import { render, staticRenderFns } from "./knowledgeStore.vue?vue&type=template&id=76238960&scoped=true"
import script from "./knowledgeStore.vue?vue&type=script&lang=js"
export * from "./knowledgeStore.vue?vue&type=script&lang=js"
import style0 from "./knowledgeStore.vue?vue&type=style&index=0&id=76238960&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76238960",
  null
  
)

export default component.exports